import { Carousel } from '../carousel/Carousel';
import { returnFalse } from '@ardoq/common-helpers';
import { modal } from '@ardoq/modal';
import { I18nLocale } from '@ardoq/i18n';
import { getEphemeralNotificationConfigs } from '../ephemeralNotificationConfig';
import { EphemeralNotificationKeys } from '../types';
import { toCarouselConfigurableProps } from '../utils';

/**
 * Imperatively opens an ephemeral notification as a modal carousel.
 * Bypasses the normal notification lifecycle, including the date window.
 * Only for user-triggered re-open entries of a live `modal` notification; does
 * nothing for other kinds. See "Usage rules" in `../AGENTS.md`.
 */
export const openEphemeralModalNotification = (
  key: EphemeralNotificationKeys,
  i18nLocale: I18nLocale
) => {
  const config = getEphemeralNotificationConfigs(i18nLocale).get(key);
  if (config?.kind !== 'modal') return;

  modal(
    closeModal => (
      <Carousel
        {...toCarouselConfigurableProps(config)}
        i18nLocale={i18nLocale}
        onClose={() => {
          closeModal(returnFalse);
        }}
        onPrimaryActionClick={() => {
          closeModal(returnFalse);
          config.onActionButtonClick?.();
        }}
      />
    ),
    { shouldCloseOnBackdropClick: false }
  );
};
